module.exports = __webpack_public_path__ + "img/footer_icon4.7901a2b0.png";